import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01a2a57a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt", "width", "height"]

import { Image } from '@/types/image';

interface Props {
	image: Image;
	imageSize: 'thumbnail' | 'medium_large';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ContentImage',
  props: {
    image: {},
    imageSize: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.image)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _ctx.image.sizes[_ctx.imageSize],
        alt: _ctx.image.alt ||'',
        width: _ctx.image.sizes[`${_ctx.imageSize}-width`],
        height: _ctx.image.sizes[`${_ctx.imageSize}-height`]
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})